import { eventService } from '@/services/event.service'
import { mapActions } from 'vuex'

export default {
    name: 'EventTypeDialogDataTabComponent',
    components: {},
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model del formulario
        isValidForm: false,
        // errores para los textfields de locales
        esTextfieldErrors: [],
        enTextfieldErrors: [],
        ptTextfieldErrors: []
    }),
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        /**
         * actions del snackbar
         */
        ...mapActions('snackbar', [
            'showSnackbar',
            'closeSnackbar'
        ]),
        /**
         * actions del dialog
         */
        ...mapActions('dialog', [
            'openDialog',
            'closeDialog'
        ]),
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pullBread',
            'pushBread'
        ]),
        /**
         * Resetea los campos del formulario de creación/actualización
         */
        resetFields() {
            if (this.$refs.eventTypeDialogForm) {
                this.$refs.eventTypeDialogForm.reset()
            }
        },
        /**
         * Valida una traducción con las demás existentes en la collection
         * @param {*} translation
         * @param {*} locale
         */
        async validateTranslation(translation, locale) {
            // true si se puede usar, false en caso contrario
            const validation = await eventService.validateTranslation(locale, translation, this.model._id)

            // agrego/limpio el mensaje de error en el textfield correspondiente
            switch (locale) {
                case 'es':
                    if (!validation) {
                        this.esTextfieldErrors = []
                        this.esTextfieldErrors.push(this.$t('eventType.error.invalidNameES'))
                    } else {
                        this.esTextfieldErrors = []
                    }
                    break;
                case 'en':
                    if (!validation) {
                        this.enTextfieldErrors = []
                        this.enTextfieldErrors.push(this.$t('eventType.error.invalidNameEN'))
                    } else {
                        this.enTextfieldErrors = []
                    }
                    break;
                case 'pt':
                    if (!validation) {
                        this.ptTextfieldErrors = []
                        this.ptTextfieldErrors.push(this.$t('eventType.error.invalidNamePT'))
                    } else {
                        this.ptTextfieldErrors = []
                    }
                    break;
                default:
                    console.error('Locale no implementado!')
            }
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.eventTypeDialogForm) {
                this.$refs.eventTypeDialogForm.resetValidation()
            }
        }
    }
}
